import React from 'react'
import styles from './TwoCol.scss'
import { CollapseProvider } from './TwoColContexts'
import cx from 'classnames'

export const ColWrap = ({ className, withCollapseProvider, children, ...props }) => {
  const wrap = <div className={cx(styles.ColWrap, className)} {...props}>
    {children}
  </div>

  return withCollapseProvider
    ? <CollapseProvider>
      {wrap}
    </CollapseProvider>
    : wrap
}

export const MainCol = ({ className, ...props }) => (
  <div className={cx(styles.MainCol, className)} {...props} />
)

export const SecondaryCol = ({ className, ...props }) => (
  <div className={cx(styles.SecondaryCol, className)} {...props} />
)
